import { Typography } from '@mui/material'
import { useT } from '@clara/locale'
import { Button, EmptyState } from '@clara/ui'
import { useLocation, useNavigate } from 'react-router-dom'
import ErrorImage from '@/assets/images/loading-error.svg'

export const GeneralError = () => {
  const { t } = useT('reimbursements')
  const navigate = useNavigate()
  const location = useLocation()
  const isInErrorPage = location.pathname.includes('/error')
  return (
    <EmptyState
      imageUrl={ErrorImage}
      headline={
        <Typography variant="h2">{t('emptystate.load.error.title')}</Typography>
      }
      sx={(theme) => ({ marginTop: theme.spacing(9) })}
      tagline={
        <Typography mt={2} mb={5}>
          {t('emptystate.load.error.description')}
        </Typography>
      }
      primaryAction={
        <Button
          variant="secondary"
          onClick={() =>
            isInErrorPage ? navigate('/reimbursements') : navigate(0)
          }
          sx={{ minWidth: '210px' }}
        >
          {t('emptystate.load.error.action')}
        </Button>
      }
    />
  )
}
